import Icon from '@components/Icon';
import TapArea from '@components/TapArea';
import { memo, useCallback } from 'react';

import type { IOption } from './PopoverButton';

interface Props {
  option: IOption;
  onSelect: () => void;
}

const PopoverButtonOptionItem: IComponent<Props> = memo(
  ({ option, onSelect }) => {
    const handleClick = useCallback(() => {
      onSelect();
      option.onClick?.();
    }, [onSelect, option]);

    return (
      <li role="none">
        <TapArea
          py={8}
          px={16}
          borderless
          role="menuitem"
          onClick={handleClick}
          disabled={option.disabled}
          tabIndex={option.disabled ? -1 : 0}
          aria-disabled={option.disabled || undefined}
        >
          {option.icon && <Icon icon={option.icon} size={16} />}
          {option.label}
        </TapArea>
      </li>
    );
  },
);

PopoverButtonOptionItem.displayName = 'PopoverButtonOptionItem';

export default PopoverButtonOptionItem;
